

export const Button = ({ text, className, type, onClick }) => {
  return (
    <button 
      className={`${className} bg-emerald-400  rounded-lg  p-2.5 text-blue-800 font-bold text-xl saturate-[.6]`} 
      type={type} 
      onClick={onClick}>
      {text}
    </button>
  );
};
